/* eslint-disable max-len */

import {
  SPOTTING_GROUP_SET_TERM_IDS,
  SPOTTING_GROUP_SET_CURRENT_TERM_NAME,
  SPOTTING_GROUP_SET_LIST_EDIT_STATE,
  SPOTTING_GROUP_EDITING_SET_EDIT_WORDS_CHECKLIST,
  SPOTTING_GROUP_ADD_TERMS,
  SPOTTING_GROUP_FETCH_TERMS,

  SPOTTING_GROUP_SET_LIST_STATE,
  SPOTTING_GROUP_SET_LIST_STATE_NOT_LOADED,
  SPOTTING_GROUP_SET_LIST_STATE_LOADING,
  SPOTTING_GROUP_SET_LIST_STATE_LOADED,
  SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR,
  SPOTTING_GROUP_SET_CLEAR_FLAG,

  SPOTTING_GROUP_SET_EDITING_STATE,
  SPOTTING_GROUP_SET_EDITING_STATE_NOT_LOADED,
  SPOTTING_GROUP_SET_EDITING_STATE_LOADING,
  SPOTTING_GROUP_SET_EDITING_STATE_LOADED,
  SPOTTING_GROUP_SET_EDITING_STATE_LOAD_ERROR,

  SPOTTING_GROUP_LIST_STATE_NOT_LOADED,
  SPOTTING_GROUP_LIST_STATE_LOADING,
  SPOTTING_GROUP_LIST_STATE_LOADED,
  SPOTTING_GROUP_LIST_STATE_ERROR,

  SPOTTING_GROUP_EDITING_STATE_NOT_LOADED,
  SPOTTING_GROUP_EDITING_STATE_LOADING,
  SPOTTING_GROUP_EDITING_STATE_LOADED,
  SPOTTING_GROUP_EDITING_STATE_ERROR,
  SPOTTING_GROUP_DOWNLOAD_GROUP,

  SPOTTING_GROUP_START_ADDING_GROUP,
  SPOTTING_GROUP_SAVE_ADDING_GROUP,
  SPOTTING_GROUP_STOP_ADDING_GROUP,

  SPOTTING_GROUP_ADDING_STATE_NOT_ADDING_GROUP,
  SPOTTING_GROUP_ADDING_STATE_ADDING_GROUP,
  SPOTTING_GROUP_ADDING_STATE_SAVING_GROUP,
  SPOTTING_GROUP_SET_ADDING_STATE,

  SPOTTING_GROUP_SET_NEW_GROUP_NAME,
  SPOTTING_GROUP_SET_NEW_GROUP_TERMS,
  SPOTTING_GROUP_SET_NEW_GROUP_WEIGHT,
  SPOTTING_GROUP_ADDING_GROUP_RESET,
  SPOTTING_GROUP_SET_TAB_KEY,
  SPOTTING_GROUP_ADD_NEW_GROUP,
  SPOTTING_GROUP_DELETE_CHECKED_LISTS,
  SPOTTING_GROUP_DELETE_ONE,
} from './spottingGroupConstants';

import { updateAction, makeSetValueAction, makeAction, keyToValueAction } from '../utils';
import { VOCABULARY_LIST_SET_CLEAR_FLAG } from '../terminus/terminusConstants';

// ------------ ACTIONS

const mutators = new Map();

const providers = {
  setTabKey: keyToValueAction(mutators, SPOTTING_GROUP_SET_TAB_KEY, 'tabKey'),
  fetchTerms: makeAction(mutators, SPOTTING_GROUP_FETCH_TERMS, s => s),
  downloadGroupCSV: makeAction(mutators, SPOTTING_GROUP_DOWNLOAD_GROUP, s => s),
  deleteCheckedLists: makeAction(mutators, SPOTTING_GROUP_DELETE_CHECKED_LISTS, s => s),
  setTermIDs: keyToValueAction(mutators, SPOTTING_GROUP_SET_TERM_IDS, 'termIDs'),
  setCurrentGroupNameID: updateAction(mutators, SPOTTING_GROUP_SET_CURRENT_TERM_NAME, 'groupName'),
  addNewGroup: updateAction(
    mutators, SPOTTING_GROUP_ADD_NEW_GROUP,
    state => state,
  ),
  deleteSpottingGroup: makeAction(mutators, SPOTTING_GROUP_DELETE_ONE, s => s),
  // these are toggles for the edit state of the list - the "Edit" button.
  setListEditState: keyToValueAction(mutators, SPOTTING_GROUP_SET_LIST_EDIT_STATE, 'listEditState'),
  setListStateChecks: keyToValueAction(mutators, SPOTTING_GROUP_EDITING_SET_EDIT_WORDS_CHECKLIST, 'listChecklist'),

  setListState: keyToValueAction(mutators, SPOTTING_GROUP_SET_LIST_STATE, 'listState'),
  setListStateNotLoaded: makeSetValueAction(mutators, SPOTTING_GROUP_SET_LIST_STATE_NOT_LOADED, 'listState', SPOTTING_GROUP_LIST_STATE_NOT_LOADED),
  setListStateLoading: makeSetValueAction(mutators, SPOTTING_GROUP_SET_LIST_STATE_LOADING, 'listState', SPOTTING_GROUP_LIST_STATE_LOADING),
  setListStateLoaded: makeSetValueAction(mutators, SPOTTING_GROUP_SET_LIST_STATE_LOADED, 'listState', SPOTTING_GROUP_LIST_STATE_LOADED),
  setListStateLoadError: makeSetValueAction(mutators, SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR, 'listState', SPOTTING_GROUP_LIST_STATE_ERROR),
  setListClearFlag: keyToValueAction(mutators, SPOTTING_GROUP_SET_CLEAR_FLAG, 'listChecklistClearFlag'),

  setAddingState: keyToValueAction(mutators, SPOTTING_GROUP_SET_ADDING_STATE, 'addGroupState'),
  setAddingStateNotAdding: makeSetValueAction(mutators, SPOTTING_GROUP_STOP_ADDING_GROUP, 'addGroupState', SPOTTING_GROUP_ADDING_STATE_NOT_ADDING_GROUP),
  setAddingStateAdding: makeSetValueAction(mutators, SPOTTING_GROUP_START_ADDING_GROUP, 'addGroupState', SPOTTING_GROUP_ADDING_STATE_ADDING_GROUP),
  setAddingStateSaving: makeSetValueAction(mutators, SPOTTING_GROUP_SAVE_ADDING_GROUP, 'addGroupState', SPOTTING_GROUP_ADDING_STATE_SAVING_GROUP),

  setAddGroupName: keyToValueAction(mutators, SPOTTING_GROUP_SET_NEW_GROUP_NAME, 'addingGroupName'),
  setAddGroupTerms: keyToValueAction(mutators, SPOTTING_GROUP_SET_NEW_GROUP_TERMS, 'addingGroupTerms'),
  setAddGroupWeight: keyToValueAction(mutators, SPOTTING_GROUP_SET_NEW_GROUP_WEIGHT, 'addingGroupWeight'),
  addingGroupReset: makeAction(mutators, SPOTTING_GROUP_ADDING_GROUP_RESET, (state) => {
    const newState = Object.assign({}, state, {
      addingGroupName: '',
      addingGroupTerms: '',
      addingGroupWeight: 1,
      addingGroupTermsList: [],
      tabKey: 'preview',
    });
    return newState;
  }),

  setEditingState: keyToValueAction(mutators, SPOTTING_GROUP_SET_EDITING_STATE, 'editingState'),
  setEditingStateNotLoaded: makeSetValueAction(mutators, SPOTTING_GROUP_SET_EDITING_STATE_NOT_LOADED, 'editingState', SPOTTING_GROUP_EDITING_STATE_NOT_LOADED),
  setEditingStateLoading: makeSetValueAction(mutators, SPOTTING_GROUP_SET_EDITING_STATE_LOADING, 'editingState', SPOTTING_GROUP_EDITING_STATE_LOADING),
  setEditingStateLoaded: makeSetValueAction(mutators, SPOTTING_GROUP_SET_EDITING_STATE_LOADED, 'editingState', SPOTTING_GROUP_EDITING_STATE_LOADED),
  setEditingStateLoadError: makeSetValueAction(mutators, SPOTTING_GROUP_SET_EDITING_STATE_LOAD_ERROR, 'editingState', SPOTTING_GROUP_EDITING_STATE_ERROR),
};

// -------------- RESOLVER

const initialValue = {
  termIDs: [],
  listChecklist: [],
  tabKey: 'preview',
  listState: SPOTTING_GROUP_LIST_STATE_NOT_LOADED,
  listEditState: false,
  listChecklistClearFlag: false,
  editingState: SPOTTING_GROUP_EDITING_STATE_NOT_LOADED,
  addGroupState: SPOTTING_GROUP_ADDING_STATE_NOT_ADDING_GROUP,
  addingGroupName: '',
  addingGroupTerms: '',
  addingGroupWeight: 1,
  addingGroupTermsList: [],
};

const resolver = (state = initialValue, { type, payload }) => {
  if (!mutators.has(type)) {
    return state;
  }

  return mutators.get(type)(state, payload);
};

export default resolver;

const actions = Array.from(mutators.keys());

export {
  actions,
  providers,
};
